import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  barClubDeleteRequest,
  barClubResetState,
  barClubViewAllByWholesalerIdRequest,
  barClubViewAllRequest,
  barClubViewSearchByWholesalerIdViewAllRequest,
} from "../../../redux/barclub/BarClubAction";
import { getColumnWidth } from "../../../style/datagridMQ";
import { filterStyles, styles } from "../../components/LoginStyles";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import CustomDataGrid from "../../constant/commondatagrid";
import DeleteDialog from "../../constant/commonDeleteDialogBox";
import Pagination from "../../constant/CommonPagenation";
import LicenseDialog from "../../constant/CommonViewDialogbox";
import CommonSnackbar from "../../notification/Snackbar";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import { LicenseProofCell, BarImageCell } from "../../constant/imageList";
import { CircleLoader } from "react-spinners";

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/wholesaler/bar/edit/${user.id}`);
  };

  const handleDelete = () => {
    onDelete(user.id);
    handleClose();
  };

  const handleParticularDetails = () => {
    navigate(`/wholesaler/bar/view/${user.id}`, {
      state: {
        vendor: user,
      },
    });
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleParticularDetails} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const BarClubSalesReport = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [openLicenseDialog, setOpenLicenseDialog] = useState(false);
  const [selectedLicenseProof, setSelectedLicenseProof] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchTerm, setSearchTerm] = useState("");

  const id = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  const barClubViewAllState = useSelector(
    (state) => state?.barClub?.viewAllBarClubByWholesalerId || {}
  );

  const barClubList = barClubViewAllState?.data || [];
  const totalRecords = barClubViewAllState?.totalRecords || 0;
  const barClubPageSize = barClubViewAllState?.pageSize || 10;

  const barClubDeleteState = useSelector(
    (state) => state.barClub?.deleteBarClub || {}
  );

  const columns = (handleDeleteRow) => [
    {
      field: "bar_image",
      headerName: "Bar/Club Images",
      width: getColumnWidth("column"),
      renderCell: (params) => <BarImageCell images={params.value} />,
    },
    {
      field: "govt_id_image",
      headerName: "License Proof",
      width: getColumnWidth("column"),
      renderCell: (params) =>
        params.value && params.value.length > 0 ? (
          <LicenseProofCell values={params.value} />
        ) : (
          <span>Proof not available</span>
          // <span style={{ color: "gray", fontStyle: "italic" }}>Proof not available</span>
        ),
    },
    {
      field: "reg_no",
      headerName: "Register No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Unknown",
    },
    {
      field: "name",
      headerName: "Bar Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Unknown",
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "First Name Not Provided",
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Last Name Not Provided",
    },
    {
      field: "email",
      headerName: "Email",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Email Not Provided",
    },
    {
      field: "contact",
      headerName: "Phone No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Phone Number Not Provided",
    },
    {
      field: "address",
      headerName: "Address",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Address Provided",
    },
    {
      field: "google_map_location",
      headerName: "Google Map Location",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Location Not Provided",
    },
    {
      field: "longitude",
      headerName: "Longitude",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Longitude Not Provided",
    },
    {
      field: "latitude",
      headerName: "Latitude",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Latitude Not Provided",
    },
    {
      field: "shop_open_and_close_time",
      headerName: "Shop Open and Close Time",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Not Specified",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("action"),
      renderCell: (params) => (
        <ActionMenu user={params.row} onDelete={handleDeleteRow} />
      ),
    },
  ];

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    if (!id) return;

    const debounceTimer = setTimeout(() => {
      dispatch(
        barClubViewAllByWholesalerIdRequest(id, currentPage, searchTerm)
      );
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [dispatch, id, currentPage, searchTerm]);

  useEffect(() => {
    if (barClubViewAllState?.success) {
      setRows(barClubList);
    } else {
      setRows(emptyList);
    }
  }, [barClubList]);

  useEffect(() => {
    if (barClubDeleteState?.success) {
      const newPage =
        rows.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

      dispatch(barClubViewAllByWholesalerIdRequest(id, newPage, searchTerm));
      dispatch(barClubResetState());
    }
  }, [barClubDeleteState?.success]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setUserToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(barClubDeleteRequest(userToDelete));
    setUserToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Bar Name Asc":
        sortedRows.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case "Sort by Bar Name Desc":
        sortedRows.sort((a, b) => b?.name?.localeCompare(a?.name));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleAddBar = () => {
    navigate(APP_LINKS.ADDBARAGGREGATION);
  };

  return (
    <>
      <Grid container spacing={2} pl={6}>
        <Grid item xs={12} sm={12} md={6} lg={8} xl={9}>
          <Box className="headingTable">
            <h1>Partnered Bars & Clubs</h1>
            <p>Here is the complete list of Partnered Bars/Clubs data</p>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              onClick={handleAddBar}
              sx={styles.addButtonColor}
            >
              Add New
            </Button>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Asc")}
          >
            Bar Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Desc")}
          >
            Bar Name Z-A
          </MenuItem>
        </Menu>

        <Paper>
          {/*search*/}
          {barClubViewAllState?.inProgress && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgcolor="rgba(255, 255, 255, 0.5)"
              zIndex={1000}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <CircleLoader
                  loading={barClubViewAllState?.inProgress}
                  size={50}
                  color="#0458d3"
                />
              </Box>
            </Box>
          )}

          {barClubDeleteState?.inProgress && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgcolor="rgba(255, 255, 255, 0.5)"
              zIndex={1001}
            >
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <CircleLoader
                  loading={barClubDeleteState?.inProgress}
                  size={50}
                  color="#d32f2f"
                />
              </Box>
            </Box>
          )}

          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by bar name or reg no..."
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          {/* {barClubViewAllState?.success && ( */}
          <>
            <Box>
              <CustomDataGrid
                rows={rows}
                columns={columns(handleDeleteRow)}
                pageSize={barClubPageSize}
                pagination={true}
                onSelectionModelChange={(newSelection) => {
                  setSelection(newSelection);
                }}
                rowHeight={100}
                loading={barClubViewAllState?.inProgress}
              />
              {selection.length > 0 && (
                <div>
                  <h2>Selected Rows:</h2>
                  {selection.map((id) => (
                    <div key={id}>
                      {rows.find((row) => row?.id === id).CustomerName}
                    </div>
                  ))}
                </div>
              )}
            </Box>
          </>
          {/* )}*/}
        </Paper>
        {barClubViewAllState?.success && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalRecords={totalRecords}
            pageSize={barClubPageSize}
          />
        )}
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={confirmDelete}
        />
        <LicenseDialog
          open={openLicenseDialog}
          onClose={() => setOpenLicenseDialog(false)}
          licenseProof={selectedLicenseProof}
        />
        {/* Snackbar */}
        <CommonSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
      </StyledContainer>
    </>
  );
};

export default BarClubSalesReport;
